module.exports = __webpack_public_path__ + "img/gifting-online.7b998e06.svg";